module.exports = __webpack_public_path__ + "static/img/bassmaster.93f5fcb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark2/ls37-1/bassmaster.png
// module id = 2D9g
// module chunks = 12